import styled from 'styled-components';
import { rgba } from 'polished';

const LoaderContainer = styled.div`
  position: ${p => p.$position};
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: ${p => {
    const bg = p.$bg || p.theme.palette.background.default;

    return p.$fullFilled ? bg : rgba(bg, 0.8);
  }};
  z-index: ${p => p.$zIndex || 1101};

  .loader {
    &__text {
      margin-top: 15px;

      -webkit-animation: fadein 1s; /* Safari, Chrome and Opera > 12.1 */
      -moz-animation: fadein 1s; /* Firefox < 16 */
      -ms-animation: fadein 1s; /* Internet Explorer */
      -o-animation: fadein 1s; /* Opera < 12.1 */
      animation: fadein 1s;
    }
  }
`;

export default LoaderContainer;
